import type { CalloutVariant } from "../extensions/callout-variant"
import {
	DEFAULT_CALLOUT_VARIANT,
	readCalloutVariant,
} from "../extensions/callout-variant"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
}

export const CALLOUT_TAG_BY_VARIANT: Record<CalloutVariant, string> = {
	note: "Note",
	info: "Note",
	neutral: "Info",
	tip: "Tip",
	check: "Check",
	warning: "Warning",
	danger: "Danger",
	success: "Check",
}

const indent = (block: string): string =>
	block
		.split("\n")
		.map((line) => (line.trim() ? `  ${line}` : line))
		.join("\n")

const variantOf = (node: Node): CalloutVariant =>
	readCalloutVariant((node as HTMLElement).getAttribute("data-callout"))

// A plain quote stays `>`: it reads back as the default Note, and the same
// writer turns comments into Linear markdown, where a <Note> tag means nothing.
export function addCalloutsMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("mintlifyCallout", {
		filter: (node) =>
			node.nodeName === "BLOCKQUOTE" &&
			variantOf(node) !== DEFAULT_CALLOUT_VARIANT &&
			variantOf(node) !== "info",
		replacement: (content, node) => {
			const tag = CALLOUT_TAG_BY_VARIANT[variantOf(node)]
			const body = content.trim()
			if (!body) return ""
			return `\n\n<${tag}>\n${indent(body)}\n</${tag}>\n\n`
		},
	})
}
